import { render, staticRenderFns } from "./growing-textarea.vue?vue&type=template&id=47c74ab7&scoped=true&lang=pug&"
import script from "./growing-textarea.vue?vue&type=script&lang=js&"
export * from "./growing-textarea.vue?vue&type=script&lang=js&"
import style0 from "./growing-textarea.vue?vue&type=style&index=0&id=47c74ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c74ab7",
  null
  
)

export default component.exports